<template>
  <div v-loading="isLoading">
    <el-row :gutter="30" v-if="!$store.getters.user.readonly">
      <el-col
        v-if="
          validarRevisar(inventario, actualContract) && revisiones.length === 0
        "
        :md="24"
      >
        <el-alert
          style="color: orangered; border: 1px solid orangered; font-size: 14px"
          type="warning"
          show-icon
          :closable="false"
          >AÚN NO SE HA REALIZADO LA REVISIÓN ANUAL DE ESTE INVENTARIO</el-alert
        >
        <br />
      </el-col>
    </el-row>

    <div v-if="!$store.getters.user.readonly">
      <div
        v-loading="load"
        v-if="
          (!validarAprobadoNull() &&
            validarRevisar(inventario, actualContract) &&
            (isAdmin === true ||
              ['contractor_coordinator', 'coordinator'].includes(
                $store.getters.role.role
              ))) ||
          validarAprobado()
        "
        element-loading-text="Cargardo..."
      >
        <el-card
          v-loading="loading_send"
          element-loading-text="Cargardo..."
          :body-style="{ padding: '0px' }"
          v-if="
            (borrador === false &&
              !validarAprobadoNull() &&
              validarRevisar(inventario, actualContract) &&
              (isAdmin === true ||
                ['contractor_coordinator', 'coordinator'].includes(
                  $store.getters.role.role
                ))) ||
            validarAprobado()
          "
          :header="`REALIZAR REVISIÓN ANUAL`"
          style="margin-bottom: 30px"
          class="intermitente"
        >
          <br />
          <el-row :gutter="20">
            <el-col :sm="24">
              <el-button
                v-if="$store.getters.cambios.length === 0"
                @click="withoutChanges"
                type="danger"
                size="small"
                >NO SE REALIZÓ NINGÚN CAMBIO EN EL INVENTARIO</el-button
              >
              <el-button
                @click="openEditInventory"
                icon="el-icon-refresh"
                type="success"
                size="small"
                >REALIZAR CAMBIOS
              </el-button>
            </el-col>
          </el-row>
          <br />
          <el-row>
            <el-col :sm="24">
              <el-table
                empty-text="NO SE HAN REALIZADO CAMBIOS"
                header-cell-class-name="header-cell-class-table-gray"
                :data="$store.getters.cambios"
                style="width: 100%"
                :default-sort="{ prop: 'num', order: 'descending' }"
                max-height="255"
              >
                <el-table-column width="260" label="Fecha" sortable>
                  <template slot-scope="scope">
                    {{ getHumanDate(scope.row.date) }}
                  </template>
                </el-table-column>
                <el-table-column prop="tarea" label="Tarea"> </el-table-column>
                <el-table-column prop="riesgo" label="Riesgo">
                </el-table-column>
                <el-table-column prop="descripcion" label="Cambio realizado">
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :sm="24" v-if="$store.getters.cambios.length > 0">
              <br /><br />
              <el-button
                type="primary"
                icon="el-icon-success"
                @click="addRevision"
                >{{ $t("Enviar revisión") }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>
        <el-alert
          v-if="borrador === true"
          style="margin-bottom: 20px"
          title="Borrador encontrado"
          type="info"
          show-icon
        >
          <div style="margin-top: 7px; font-size: 15px; color: black">
            Se ha encontrado el borrador de sus últimas modificaciones
            realizadas en la revisión anual, para restaurarlos y continuar con
            el proceso de revisión debe hacer clic en el boton
            <b>Restaurar Cambios</b>
            <br />
            <el-button
              @click="restoreBorrador"
              icon="el-icon-refresh"
              style="margin-top: 10px"
              size="mini"
              type="primary"
              >Restaurar Cambios</el-button
            >
          </div>
        </el-alert>
      </div>
      <el-card
        v-loading="loading_anual"
        element-loading-text="Cargardo..."
        :body-style="{ padding: '0px' }"
        v-if="
          (validarAprobadoNull() &&
            $store.getters.role.role &&
            ['super'].includes($store.getters.role.role) &&
            contract.tipo_contrato === 'Propio') ||
          (validarAprobadoNull() &&
            $store.getters.role.role &&
            ['owner', 'contract_owner'].includes($store.getters.role.role) &&
            contract.tipo_contrato === 'Contratista') ||
          (validarAprobadoNull() && isAdmin === true)
        "
        :header="`EVALUAR REVISIÓN ANUAL`"
        style="margin-bottom: 30px"
        class="intermitente"
      >
        <center>
          <el-button
            icon="el-icon-back"
            style="margin-bottom: 10px; margin-top: 10px"
            size="medium"
            v-if="verDetalles === true"
            type="info"
            @click="verDetalles = false"
            >Regresar</el-button
          >
        </center>
        <br />
        <el-table
          header-cell-class-name="header-cell-class-table-gray"
          v-if="verDetalles === false"
          :data="[
            revisiones.length == 1
              ? revisiones[0]
              : revisiones[revisiones.length - 1],
          ]"
          style="width: 100%"
        >
          <el-table-column label="Fecha">
            <template slot-scope="scope">
              {{
                scope.row && scope.row.date ? getHumanDate(scope.row.date) : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="aprobado" label="Estado">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row && scope.row.aprobado === true"
                type="success"
                >Aprobado</el-tag
              >
              <el-tag
                v-if="scope.row && scope.row.aprobado === false"
                type="danger"
                >Rechazado</el-tag
              >
              <el-tag
                v-if="scope.row && scope.row.aprobado === null"
                type="info"
                >En evaluación</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="Último mensaje">
            <template slot-scope="scope">
              <div v-if="scope.row">
                {{
                  revisiones.length === 1
                    ? revisiones[0]["mensaje"]
                    : revisiones[1]["mensaje"]
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="350px">
            <template slot-scope="scope">
              <el-button
                @click="setCambios(scope.row.nota)"
                type="warning"
                size="small"
                >Ver cambios</el-button
              >
              <el-button
                @click="setStatusEvaluacion(true)"
                type="success"
                size="small"
                >Aprobar</el-button
              >
              <el-button
                @click="setStatusEvaluacion(false)"
                type="danger"
                size="small"
                >Rechazar</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-table
          header-cell-class-name="header-cell-class-table-gray"
          v-else
          :data="cambios"
          style="width: 100%"
          :key="verDetalles"
        >
          <el-table-column prop="tarea" label="Tarea"> </el-table-column>
          <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
          <el-table-column prop="descripcion" label="Cambio realizado">
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <el-row :gutter="30">
      <!--linea 1-->
      <el-col :md="24" class="text_align_right">
        <el-button
          v-loading="loading_ds44"
          :disabled="loading_ds44"
          size="small"
          type="warning"
          style="margin-right: 40px"
          icon="el-icon-document"
          @click="dialogVisible = true"
        >
          Exportar a formato DS44
        </el-button>
        <el-button
          size="medium"
          type="info"
          style="margin-right: 40px"
          icon="el-icon-view"
          v-if="revisiones.length > 0"
          @click="openDialogListReviewer"
          >Ver Revisiones Anuales</el-button
        >
        <el-dropdown
          size="small"
          v-if="backups.length > 0"
          split-button
          type="primary"
          @command="getPDFBackup"
          style="margin-right: 40px"
        >
          Versiones anteriores aprobadas
          <i class="el-icon-download"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="{ id: item._id, version: index + 1 }"
              v-for="(item, index) in backups"
              :key="item._id"
            >
              <span style="font-family: Arial, Helvetica, sans-serif"
                >Versión {{ index + 1 }} /
                {{ formatDate(item.created_at) }}</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span
          v-if="!isActiveContract(actualContract)"
          class="inventario_estado inventario_estado_vencido"
          >{{ $t("Vencido") }}</span
        >
        <span
          :class="`inventario_estado inventario_estado_${inventario.status}`"
          >{{
            $t(
              inventario_estado[
                inventario.wasApproved === true &&
                [0, 1, "0", "1"].includes(parseInt(inventario.status))
                  ? `${inventario.status}wasApproved`
                  : inventario.status
              ]
            )
          }}</span
        >
        <el-button
          style="background-color: white"
          class="button_img margen_r_l_20px"
          v-if="inventario.status == 1"
          @click="downloadPDFReview"
          :loading="isLoadingPDF"
          size="small"
        >
          <img src="@/assets/icons/pdf.gif" width="40px" />
          <br />
          <span>{{ $t("Revisión") }}</span>
        </el-button>

        <el-button
          style="background-color: white"
          class="button_img margen_r_l_20px"
          v-if="inventario.status == 2"
          @click="downloadPDF"
          :loading="isLoadingPDF"
          size="small"
        >
          <img src="@/assets/icons/pdf.gif" width="40px" />
          <br />
          <span>{{ $t("Completo") }}</span>
        </el-button>
        <el-button
          style="background-color: white"
          class="button_img"
          size="small"
          v-if="
            (inventario.status == 2 || inventario.status == 3) && medioambiental
          "
          @click="downloadPDFMedioambiente"
          :loading="isLoadingPDFMedioambiente"
        >
          <img src="@/assets/icons/pdf.gif" width="40px" />
          <br />
          <span>{{ $t("Medioambiente") }}</span>
        </el-button>
        <el-button
          style="background-color: white"
          v-if="
            (inventario.status != 0 &&
              inventario.status != 4 &&
              rolesCoordinator[$store.getters.role.role] &&
              !validarRevisar(inventario, actualContract)) ||
            (isAdmin === true &&
              isActiveContract(actualContract) &&
              !$store.getters.user.readonly)
          "
          @click="openMotivo()"
          size="small"
          class="button_img"
        >
          <img src="@/assets/icons/borrador.gif" width="40px" />
          <br />
          {{ $t("Cambiar a borrador") }}
        </el-button>
        <el-button
          style="background-color: white"
          v-if="
            (inventario.status != 0 && inventario.status != 4) ||
            (isAdmin === true && isActiveContract(actualContract))
          "
          @click="descargarExcel()"
          size="small"
          class="button_img"
        >
          <img src="@/assets/icons/xlsx.png" width="40px" />
          <br />
          {{ $t("Descargar Excel") }}
        </el-button>
      </el-col>
    </el-row>
    <br />

    <el-row
      v-if="
        inventario.status == 4 &&
        (this.$store.getters.role.role === 'environment' || isAdmin === true)
      "
      :gutter="10"
    >
      <el-col :md="24">
        <el-alert type="warning" show-icon :closable="false">
          <template>
            <div
              style="margin-left: 10px; padding-top: 15px"
              v-html="$t(environmentalAlertText)"
            />
          </template>
        </el-alert>
        <br />
      </el-col>
      <el-col :md="8" :offset="13">
        <el-button
          size="medium"
          type="warning"
          class="right full-width"
          @click="openEnvironmentalConfirmationDialog(true)"
        >
          <b>Validar inventario sin riesgos Medioambientales</b>
        </el-button>
      </el-col>
      <el-col :md="3">
        <el-button
          size="medium"
          type="danger"
          class="right full-width"
          @click="openEnvironmentalConfirmationDialog(false)"
        >
          <b>Rechazar</b>
        </el-button>
      </el-col>
    </el-row>
    <br />
    <el-row>
      <!--linea 2 filtro H S E-->
      <el-col :md="24">
        <span>
          <span style="font-size: 15px"
            >{{ $t("Mostrar riesgos de tipo") }}:</span
          >
          <el-checkbox
            style="margin-left: 20px"
            size="small"
            border
            v-model="filtro_tipo_riesgo.salud"
            >{{ $t("Salud") }}</el-checkbox
          >
          <el-checkbox
            size="small"
            border
            v-model="filtro_tipo_riesgo.seguridad"
            >{{ $t("Seguridad") }}</el-checkbox
          >
          <el-checkbox
            size="small"
            border
            v-model="filtro_tipo_riesgo.medioambiente"
            >{{ $t("Medioambiente") }}
          </el-checkbox>
        </span>
      </el-col>
      <el-col :md="19">
        <div style="margin-top: 15px">
          <div style="margin-right: 20px; display: inline-block">
            <b><span style="font-size: 15px">Tipo de riesgos:</span></b>
          </div>
          <div
            style="
              margin-right: 10px;
              display: inline-block;
              width: 12px;
              height: 12px;
              background-color: rgb(227, 0, 82);
              border: 1px solid black;
            "
          ></div>
          <span style="font-size: 15px">Personalizado</span>
          <div
            style="
              margin-left: 20px;
              margin-right: 10px;
              display: inline-block;
              width: 12px;
              height: 12px;
              background-color: rgb(0, 167, 245);
              border: 1px solid black;
            "
          ></div>
          <span style="font-size: 15px">Estandarizado Salud</span>
          <div
            style="
              margin-left: 20px;
              margin-right: 10px;
              display: inline-block;
              width: 12px;
              height: 12px;
              background-color: rgb(230, 84, 0);
              border: 1px solid black;
            "
          ></div>
          <span style="font-size: 15px">Estandarizado Seguridad</span>
          <div
            style="
              margin-left: 20px;
              margin-right: 10px;
              display: inline-block;
              width: 12px;
              height: 12px;
              background-color: green;
              border: 1px solid black;
            "
          ></div>
          <span style="font-size: 15px">Estandarizado Medioambiente</span>
        </div>
      </el-col>
      <el-col :md="5">
        <el-button
          v-if="inventario.status == 2"
          @click="downloadTareasDialog = true"
          style="float: right"
          icon="el-icon-download"
          size="small"
          type="danger"
          >Descargar más de una tarea</el-button
        >
      </el-col>
    </el-row>
    <br /><br />
    <el-table
      stripe
      header-cell-class-name="header"
      :data="getTasks(inventario)"
      style="width: 100%"
      ref="tableData"
      @expand-change="rowClicked"
    >
      <!-- @row-click="rowClicked" ref="tableData"> -->
      <el-table-column type="expand" label="Expandir" width="100">
        <template slot-scope="props">
          <InventarioTable
            :copyRisks="copyRisks"
            :refreshCollapse="refreshCollapse"
            v-if="props.row.riesgos"
            :ids="ids"
            :filtro_tipo_riesgo="filtro_tipo_riesgo"
            :filtro_usuario_riesgo="filtro_usuario_riesgo"
            :task="props.row"
            :risks="getRisks(props.row)"
            :withStatus="
              inventario.status == 1 && isActiveContract(actualContract)
            "
            :contract="contract"
            :contractPeople="contractPeople"
            :workflows="workflows"
            :updateInventory="updateInventory"
          />
        </template>
      </el-table-column>
      <el-table-column width="180" label="Acción">
        <template slot-scope="props">
          <el-button
            @click="openEvaluarTarea(props.row.riesgos)"
            v-if="
              showTarea(props.row.riesgos) &&
              mostrarTarea(props.row.riesgos) &&
              !$store.getters.user.readonly &&
              [1, '1'].includes($store.getters.inventario.status)
            "
            type="primary"
            size="small"
            :disabled="validarTarea(props.row.riesgos)"
            >Enviar Tarea</el-button
          >
          <div
            style="margin-top: 8px"
            v-if="
              ['coordinator', 'contractor_coordinator'].includes(
                $store.getters.role.role
              )
            "
          >
            <el-button type="warning" size="small" @click="copyTasks(props.row)"
              >{{ $t("Copiar a otro inventario") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Nombre tarea" prop="nombre"> </el-table-column>
      <el-table-column width="160" align="center" label="Riesgos">
        <template slot-scope="props">
          <el-tag type="success" v-if="props.row.riesgos">
            <b>{{ props.row.riesgos.length }}</b>
          </el-tag>
          <el-tag type="success" v-else>
            <b>0</b>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="180" align="center" label="Procedimiento">
        <template slot-scope="props">
          <a
            :href="props.row.pdf_document"
            target="_blank"
            v-if="props.row.pdf_document"
          >
            <img class="img_pdf" src="@/assets/icons/lista.png" />
          </a>
          <el-button
            v-if="props.row.procedimiento"
            class="button_img"
            @click="ver_modal_procedimiento = props.row.procedimiento"
            size="small"
          >
            <img class="img_pdf" src="@/assets/icons/lista.png" />
          </el-button>
          <el-tag
            v-else
            :type="
              risksRuleValidation(props.row) === true &&
              (props.row.procedimiento === '' || !props.row.procedimiento)
                ? 'danger'
                : 'info'
            "
          >
            {{
              risksRuleValidation(props.row) === true &&
              (props.row.procedimiento === "" || !props.row.procedimiento)
                ? "Procedimiento pendiente"
                : "Procedimiento no requerido"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        align="center"
        :label="inventario.status == 1 ? 'Riesgos por revisar' : 'PDF Tareas'"
      >
        <template slot-scope="props">
          <el-tag type="danger" v-if="inventario.status == 1">
            <span
              v-if="
                props.row.riesgos &&
                auxTasks &&
                auxTasks[props.row.id || props.row._id] &&
                auxTasks[props.row.id || props.row._id].count
              "
            >
              <b>{{ auxTasks[props.row.id || props.row._id].count || 0 }}</b>
            </span>
            <span v-else>
              <b>0</b>
            </span>
          </el-tag>
          <span v-if="inventario.status == 2 || inventario.status == 3">
            <el-button
              icon="el-icon-download"
              v-if="inventario.status == 2 || inventario.status == 3"
              @click="downloadPDFTask([props.row._id || props.row.id])"
              :loading="isLoadingPDFTask"
              size="small"
              type="danger"
              >Descargar</el-button
            >
            <span v-else class="inventario_estado inventario_estado_0"
              >No aplica</span
            >
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="
          ($store.getters.role.admin ||
            $store.getters.role.role === 'coordinator' ||
            $store.getters.role.role === 'contractor_coordinator') &&
          !$store.getters.user.readonly
        "
        width="160"
        align="center"
        label="Ordenar"
      >
        <template slot-scope="props">
          <el-button
            style="font-size: 15px"
            plain
            size="mini"
            type="success"
            @click="moveUp(props.$index, props.row)"
            icon="el-icon-top"
          />
          <el-button
            style="font-size: 15px"
            plain
            size="mini"
            type="danger"
            @click="moveDown(props.$index, props.row)"
            icon="el-icon-bottom"
          />
        </template>
      </el-table-column>
    </el-table>
    <br />
    <br />
    <div class="text-right">
      <el-button
        size="medium"
        type="primary"
        class="big-submit"
        @click="goBack()"
        >{{ $t("Volver") }}</el-button
      >
      <template
        v-if="
          $store.getters.role.admin ||
          rolesCoordinator[$store.getters.role.role]
        "
      >
        <el-button
          size="medium"
          v-if="
            (!inventario.status || inventario.status == 0) &&
            isActiveContract(actualContract) &&
            (['contractor_coordinator', 'coordinator'].includes(actualRole) ||
              isAdmin === true)
          "
          type="primary"
          @click="goToTasks()"
          class="big-submit"
          >{{ $t("Seguir editando") }}</el-button
        >
      </template>
    </div>

    <!--Dialog otras versiones-->
    <el-dialog
      :before-close="handleClose"
      :title="$t('Versiones anteriores')"
      :visible="otherVersionsDialog"
      width="20%"
    >
      <div class="text-center">
        <div v-for="(url, date) in oldVersions" :key="date">
          <el-button
            class="pdfDate"
            @click="abrirOldPDF(url)"
            type="default"
            round
            >{{ date | formatDateHour }}
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="otherVersionsDialog = false">{{
          $t("Cerrar")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- Dialog confirmación medioambiente -->
    <el-dialog
      :title="$t('Validación Medioambiental')"
      :visible="environmentalConfirmationDialog"
      width="40%"
    >
      <!-- Body -->
      <br />
      <div v-if="environmentalValidation.valido">
        Al validar este inventario sin riesgos o aspectos medioambientales el
        inventario pasará a su proceso de revisión.
        <br />
        <br />¿Seguro desea validar el inventario sin riesgos o aspectos
        medioambientales?
      </div>
      <div v-else>
        Debe ingresar la razón por la cual rechaza el inventario sin riesgos o
        aspectos medioambientales. Este comentario será enviado al coordinador
        para que modifique el inventario de riesgos.
        <br />
        <br />
        <el-input
          type="textarea"
          placeholder="Ingrese motivo del rechazo"
          v-model="environmentalValidation.comentario"
        >
        </el-input>
      </div>
      <!-- Footer -->
      <br />
      <div style="text-align: right">
        <el-button
          size="small"
          @click="environmentalConfirmationDialog = false"
          >{{ $t("Cerrar") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="sendEnvironmentalValidation"
          >{{ $t("Enviar validación") }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="80%"
      title="Revisión Anual del Inventario de Riesgos"
      :show-close="false"
      :visible="addReviewer"
      :before-close="closeReviewer"
    >
      <br />
      <el-row :gutter="20">
        <el-col :sm="24">
          <el-button @click="withoutChanges" type="danger" size="small"
            >NO SE REALIZARÓN CAMBIOS</el-button
          >
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :sm="24">
          <el-table :data="nota" style="width: 100%">
            <el-table-column prop="tarea" label="Tarea"> </el-table-column>
            <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
            <el-table-column prop="descripcion" label="Cambio realizado">
            </el-table-column>
            <el-table-column width="50px">
              <template slot-scope="scope">
                <i
                  @click="deleteCambio(scope.row.id)"
                  style="font-size: 24px; color: red; cursor: pointer"
                  class="el-icon-delete"
                ></i>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeReviewer">{{ $t("Cancelar") }}</el-button>
        <el-button type="primary" @click="addRevision">{{
          $t("Guardar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Listado de revisiones anuales"
      :show-close="false"
      :visible="dialogRevisiones"
      :before-close="closeDialogRevisiones"
    >
      <br />
      <center>
        <el-button
          icon="el-icon-back"
          style="margin-bottom: 10px"
          size="medium"
          v-if="verDetalles === true"
          type="info"
          @click="verDetalles = false"
          >Regresar</el-button
        >
      </center>
      <br />
      <el-table
        height="400"
        header-cell-class-name="header-cell-class-table-gray"
        v-if="verDetalles === false"
        :data="revisiones"
        style="width: 100%"
      >
        <el-table-column label="Fecha">
          <template slot-scope="scope">
            {{ getHumanDate(scope.row.date) }}
          </template>
        </el-table-column>
        <el-table-column prop="aprobado" label="Estado">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.aprobado === true" type="success"
              >Aprobado</el-tag
            >
            <el-tag v-if="scope.row.aprobado === false" type="danger"
              >Rechazado</el-tag
            >
            <el-tag v-if="scope.row.aprobado === null" type="info"
              >En evaluación</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Mensaje">
          <template slot-scope="scope">
            {{ scope.row.mensaje }}
          </template>
        </el-table-column>
        <el-table-column width="150px">
          <template slot-scope="scope">
            <el-button
              @click="setCambios(scope.row.nota)"
              type="warning"
              size="small"
              >Ver cambios</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-table
        header-cell-class-name="header-cell-class-table-gray"
        v-else
        :data="cambios"
        style="width: 100%"
        :key="verDetalles"
      >
        <el-table-column prop="tarea" label="Tarea"> </el-table-column>
        <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
        <el-table-column prop="descripcion" label="Cambio realizado">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogRevisiones">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="80%"
      title="Evaluar revisión anual"
      :show-close="false"
      :visible="dialogEvaluacion"
      :before-close="closeDialogEvaluaciones"
    >
      <br />
      <center>
        <el-button
          icon="el-icon-back"
          style="margin-bottom: 10px"
          size="medium"
          v-if="verDetalles === true"
          type="info"
          @click="verDetalles = false"
          >Regresar</el-button
        >
      </center>
      <br />
      <el-table
        header-cell-class-name="header-cell-class-table-gray"
        v-if="verDetalles === false"
        :data="[revisiones[0]]"
        style="width: 100%"
      >
        <el-table-column label="Fecha">
          <template slot-scope="scope">
            {{ getHumanDate(scope.row.date) }}
          </template>
        </el-table-column>
        <el-table-column prop="aprobado" label="Estado">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.aprobado === true" type="success"
              >Aprobado</el-tag
            >
            <el-tag v-if="scope.row.aprobado === false" type="danger"
              >Rechazado</el-tag
            >
            <el-tag v-if="scope.row.aprobado === null" type="info"
              >En evaluación</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Último mensaje">
          <template slot-scope="scope">
            {{
              revisiones.length === 1
                ? revisiones[0]["mensaje"]
                : revisiones[1]["mensaje"]
            }}
          </template>
        </el-table-column>
        <el-table-column width="350px">
          <template slot-scope="scope">
            <el-button
              @click="setCambios(scope.row.nota)"
              type="warning"
              size="small"
              >Ver cambios</el-button
            >
            <el-button
              @click="setStatusEvaluacion(true)"
              type="success"
              size="small"
              >Aprobar</el-button
            >
            <el-button
              @click="setStatusEvaluacion(false)"
              type="danger"
              size="small"
              >Rechazar</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-table
        header-cell-class-name="header-cell-class-table-gray"
        v-else
        :data="cambios"
        style="width: 100%"
        :key="verDetalles"
      >
        <el-table-column prop="tarea" label="Tarea"> </el-table-column>
        <el-table-column prop="riesgo" label="Riesgo"> </el-table-column>
        <el-table-column prop="descripcion" label="Cambio realizado">
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialogEvaluaciones()">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      top="30px"
      :before-close="handleClose"
      title="Modificando Inventario de Riesgos"
      :visible="editInventory"
      width="90%"
    >
      <div v-if="$store.getters.step_anual === 1">
        <EditInventory :cambios="cambios" />
      </div>
      <div v-if="$store.getters.step_anual === 2">
        <Step1 :cambios="cambios" />
      </div>
      <div v-if="$store.getters.step_anual === 3">
        <Step2 :cambios="cambios" />
      </div>
      <div v-if="$store.getters.step_anual === 4">
        <Step3 :cambios="cambios" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          icon="el-icon-refresh"
          size="medium"
          type="primary"
          v-if="$store.getters.step_anual === 1"
          @click="saveTemporal"
          >Guardar cambios y Cerrar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Procedimiento')"
      :visible="ver_modal_procedimiento ? true : false"
      width="40%"
    >
      <div class="text-center">{{ ver_modal_procedimiento }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ver_modal_procedimiento = false">{{
          $t("Cerrar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      :before-close="handleClose"
      :title="$t('Enviar Tarea')"
      :visible="dialogEvaluar"
      width="90%"
    >
      <div v-loading="loading_multiple" element-loading-text="Cargando...">
        <span
          >Usted ha revisado todos los riesgos asociados a las siguientes
          tareas:</span
        >
        <br /><br />
        <h3 style="color: green">
          Aprobados
          <el-tag size="small" type="success">{{
            getQuantity(ids, "aprobar").length
          }}</el-tag>
        </h3>
        <el-card
          style="margin-bottom: 10px"
          v-for="(item, index) in getQuantity(ids, 'aprobar')"
          :key="index + 'a'"
        >
          <h3 style="font-size: 13px">
            <span style="color: orangered">Tarea: </span>{{ item.task }}
          </h3>
          <h3 style="font-size: 13px">
            <span style="color: orangered">Riesgo: </span
            >{{ item.riesgo.nombre }}
          </h3>
          <el-table
            :cell-class-name="pintar"
            row-class-name="rowClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray"
            :default-sort="{ prop: 'mfl', order: 'descending' }"
            class="tableRisks"
            :data="[item.riesgo]"
            style="width: 100%; margin-top: 20px"
            :max-height="520"
            empty-text="Sin Riesgos estandarizados"
          >
            <el-table-column type="expand" width="40" label="+">
              <template slot-scope="scope">
                <div
                  style="
                    padding-left: 30px;
                    padding-right: 30px;
                    padding-bottom: 20px;
                  "
                >
                  <el-row>
                    <el-col :span="8">
                      <h4>Causas</h4>
                      <ol>
                        <li
                          v-for="(item, index) in scope.row.causas"
                          :key="index + 'b'"
                        >
                          {{ item.nombre }}
                        </li>
                      </ol>
                    </el-col>
                    <el-col :span="8">
                      <h4>Controles Preventivos</h4>
                      <ol>
                        <li
                          :class="{ fontRed: control.critico }"
                          v-for="(control, i) in getControlesPreventivos(
                            scope.row
                          )"
                          v-bind:key="i + 'c'"
                        >
                          {{ control.nombre }}
                        </li>
                      </ol>
                    </el-col>
                    <el-col :span="8">
                      <h4>Controles Mitigadores</h4>
                      <ol>
                        <li
                          v-for="(control, i) in getControlesMitigadores(
                            scope.row
                          )"
                          v-bind:key="i + 'd'"
                        >
                          {{ control.nombre }}
                        </li>
                      </ol>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nombre" label="Nombre"></el-table-column>
            <el-table-column width="180" align="center" label="Tipo Impacto">
              <template slot-scope="scope">{{
                getMayorImpacto(scope.row).impacto.categoria
              }}</template>
            </el-table-column>
            <el-table-column width="80" align="center" label="MFL">
              <template slot-scope="scope">
                <el-tag
                  class="big"
                  v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)"
                  >{{ getMayorImpacto(scope.row).mfl }}</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <br />
        <h3 style="color: red">
          Rechazados
          <el-tag size="small" type="danger">{{
            getQuantity(ids, "rechazar").length
          }}</el-tag>
        </h3>
        <el-card
          style="margin-bottom: 10px"
          v-for="(item, index) in getQuantity(ids, 'rechazar')"
          :key="index + 'e'"
        >
          <h3 style="font-size: 13px">
            <span style="color: orangered">Tarea: </span>{{ item.task }}
          </h3>
          <h3 style="font-size: 13px">
            <span style="color: orangered">Riesgo: </span
            >{{ item.riesgo.nombre }}
          </h3>
          <el-table
            :cell-class-name="pintar"
            row-class-name="rowClassTablaPloma"
            header-cell-class-name="header-cell-class-table-gray"
            :default-sort="{ prop: 'mfl', order: 'descending' }"
            class="tableRisks"
            :data="[item.riesgo]"
            style="width: 100%; margin-top: 20px"
            :max-height="520"
            empty-text="Sin Riesgos estandarizados"
          >
            <el-table-column type="expand" width="40" label="+">
              <template slot-scope="scope">
                <div
                  style="
                    padding-left: 30px;
                    padding-right: 30px;
                    padding-bottom: 20px;
                  "
                >
                  <el-row>
                    <el-col :span="8">
                      <h4>Causas</h4>
                      <ol>
                        <li
                          v-for="(item, index) in scope.row.causas"
                          :key="index + 'f'"
                        >
                          {{ item.nombre }}
                        </li>
                      </ol>
                    </el-col>
                    <el-col :span="8">
                      <h4>Controles Preventivos</h4>
                      <ol>
                        <li
                          :class="{ fontRed: control.critico }"
                          v-for="(control, i) in getControlesPreventivos(
                            scope.row
                          )"
                          v-bind:key="i + 'g'"
                        >
                          {{ control.nombre }}
                        </li>
                      </ol>
                    </el-col>
                    <el-col :span="8">
                      <h4>Controles Mitigadores</h4>
                      <ol>
                        <li
                          v-for="(control, i) in getControlesMitigadores(
                            scope.row
                          )"
                          v-bind:key="i + 'h'"
                        >
                          {{ control.nombre }}
                        </li>
                      </ol>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="nombre" label="Nombre"></el-table-column>
            <el-table-column width="180" align="center" label="Tipo Impacto">
              <template slot-scope="scope">{{
                getMayorImpacto(scope.row).impacto.categoria
              }}</template>
            </el-table-column>
            <el-table-column width="80" align="center" label="MFL">
              <template slot-scope="scope">
                <el-tag
                  class="big"
                  v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)"
                  >{{ getMayorImpacto(scope.row).mfl }}</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column width="380" align="center" label="Observaciones">
              <template slot-scope="scope">
                <el-select
                  style="width: 100%"
                  class="with-help-box fullWidth"
                  collapse-tags
                  v-model="item.observaciones"
                  multiple
                  placeholder="Seleccione observaciones"
                >
                  <el-option
                    v-for="item in opciones_comentarios"
                    :key="item.value + 'i'"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column width="300" align="center" label="Comentario">
              <template slot-scope="scope">
                <el-input size="small" v-model="item.comentario"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        v-if="loading_multiple === false"
      >
        <el-button
          @click="
            dialogEvaluar = false;
            resetIds();
          "
          >{{ $t("Cancelar") }}</el-button
        >
        <el-button type="primary" @click="revision_multiple()">{{
          $t("Enviar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('La revisión fue exitosa')"
      :visible="dialogFinish"
      width="30%"
    >
      <br />
      <el-tag size="small" type="success">{{ total_aprobados }}</el-tag> Los
      riesgos <span style="color: green">aprobado</span>, continuando el proceso
      de aprobación. <br /><br />
      <el-tag size="small" type="danger">{{ total_rechazados }}</el-tag> Los
      riesgos <span style="color: red">rechazado</span> con comentarios, fue
      devuelto al coordinador para realizar las correcciones correspondientes.
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFinish = false">{{ $t("Cerrar") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Motivo cambio a borrador"
      :visible.sync="dialogMotivo"
      width="30%"
      :before-close="handleClose"
    >
      <br />
      <span>El cambio o incorporación del nuevo riesgo, ¿a que se debe?</span
      ><br />
      <el-select
        style="width: 100%; margin-top: 8px"
        v-model="motivo"
        placeholder="Seleccione un motivo"
        size="medium"
      >
        <el-option
          v-for="item in motivos"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="nextChangeStatus()"
          >Aceptar</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Listado de tareas')"
      :visible="downloadTareasDialog"
      width="80%"
    >
      <br />
      <el-table
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        empty-text="No hay tareas en el inventario"
        header-cell-class-name="header-cell-class-table-gray"
        :data="inventario.tareas"
        style="width: 100%"
        height="400px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="nombre" label="Tarea"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button
          :loading="isLoadingPDFTask"
          :disabled="tareas_descargas.length === 0"
          type="primary"
          @click="descargarTareasMultiple"
          >Descargar PDF</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Listado de inventarios"
      :visible.sync="copyInventoryTask"
      width="80%"
      :before-close="handleClose"
    >
      <el-form
        :inline="true"
        style="margin-top: 15px"
        onsubmit="return false;"
        label-position="left"
      >
        <el-form-item label="Tipo de contrato">
          <el-select
            class="tipoContrato"
            size="small"
            v-model="contractType"
            placeholder="Seleccione tipo"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 15px" label="Búsqueda avanzada">
          <el-input
            :placeholder="$t('Búsqueda por nombre')"
            prefix-icon="el-icon-search"
            v-model="search"
            class="search"
            size="small"
          />
        </el-form-item>
      </el-form>
      <el-alert type="info" show-icon>
        <b>Considerar los siguientes puntos.</b>
        <ol>
          <li>
            Es obligatorio que el inventario destino (donde se va copiar la
            información desde otros inventarios) debe estar en estado Borrador
            (editable).
          </li>
          <li>
            Si el inventario está en estado “No iniciado” no se podrá copiar
            información desde otros inventarios, como se señala en el primer
            punto el inventario debe estar en borrador, para esto debe contar al
            menos con la primera tarea creada de forma manual por el coordinador
            responsable.
          </li>
          <li>
            Esta función también aplica para inventarios que se encuentran
            aprobados y requieren ser actualizados en plataforma, recordar que
            antes de iniciar el proceso de copiado de información desde otros
            inventarios se debe dejar el inventario destino nuevamente en estado
            borrador.
          </li>
        </ol>
      </el-alert>
      <el-table
        v-loading="loading_inv"
        style="margin-top: 15px"
        :data="paginar === false ? inventarios : paginarInventarios()"
        class="inventoryTable"
        :max-height="700"
        :header-cell-style="{
          backgroundColor: '#242424',
          color: 'white',
          padding: '0px',
          borderWidth: '2px',
        }"
      >
        <el-table-column
          :label="$t('Nombre')"
          prop="nombre"
          sortable
        ></el-table-column>
        <el-table-column label="Estado" align="center" width="190">
          <template slot-scope="scope">
            <span
              :class="`safety-tag inventario_estado inventario_estado_${
                JSON.stringify(scope.row.inventario) !== 'null'
                  ? scope.row.inventario.status
                  : 'undefined'
              }`"
              >{{ getStatus(scope.row) }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="Estado" align="center" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="
                tipo_accion === 'tarea' &&
                scope.row.inventario &&
                ![1, 2, 4, '1', '2', '4'].includes(scope.row.inventario.status)
              "
              @click="copiarTareaInventario(scope.row)"
              size="small"
              type="warning"
              >Seleccionar</el-button
            >
            <el-button
              v-if="
                tipo_accion === 'riesgo' &&
                scope.row.inventario &&
                ![1, 2, 4, '1', '2', '4'].includes(scope.row.inventario.status)
              "
              @click="copiarRiesgoInventario(scope.row)"
              size="small"
              type="warning"
              >Seleccionar</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <center>
        <el-pagination
          :current-page="page"
          @prev-click="backPage"
          @next-click="nextPage"
          @current-change="currentPage"
          :page-size="5"
          layout="prev, pager, next"
          :total="totalPage"
        />
      </center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      append-to-body
      title="Listado de tareas"
      :visible.sync="dialogtasks"
      width="80%"
      :before-close="handleClose"
    >
      <el-table
        style="margin-top: 15px"
        :data="listado_tareas"
        class="inventoryTable"
        :max-height="700"
        :header-cell-style="{
          backgroundColor: '#242424',
          color: 'white',
          padding: '0px',
          borderWidth: '2px',
        }"
      >
        <el-table-column
          :label="$t('Nombre')"
          prop="nombre"
          sortable
        ></el-table-column>
        <el-table-column label="Opciones" align="center" width="190">
          <template slot-scope="scope">
            <el-button
              @click="copiarTareaRiesgoInventario(scope.row)"
              size="small"
              type="warning"
              >Seleccionar</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Configuración de Exportación DS44"
      :visible.sync="dialogVisible"
      width="550px"
      @close="resetValidation"
    >
      <div class="dialog-body">
        <p><b>Paso 1:</b> Descargue el instructivo técnico obligatoriamente:</p>

        <el-row :gutter="10" style="margin-top: 10px">
          <el-col :span="12">
            <a
              download
              href="/files/ds44_mel.pdf"
              @click="descargoInstructivo = true"
            >
              <el-button
                type="info"
                icon="el-icon-download"
                size="small"
                style="width: 100%; white-space: normal; height: 55px"
              >
                Descargar Instructivo DS44 <br />
                (Escondida)
              </el-button>
            </a>
          </el-col>
          <el-col :span="12">
            <a
              download
              href="/files/ds44_spence.pdf"
              @click="descargoInstructivo = true"
            >
              <el-button
                type="info"
                icon="el-icon-download"
                size="small"
                style="width: 100%; white-space: normal; height: 55px"
              >
                Descargar Instructivo DS44 <br />
                (Pampa Norte - Spence)
              </el-button>
            </a>
          </el-col>
        </el-row>

        <div style="margin-top: 25px">
          <p
            :style="{
              color: descargoInstructivo ? '#303133' : '#C0C4CC',
              fontSize: '13px',
            }"
          >
            <b>Paso 2:</b> Confirme la lectura:
          </p>
          <el-checkbox
            v-model="aceptaInstructivo"
            :disabled="!descargoInstructivo"
          >
            He leído y acepto las condiciones del instructivo
          </el-checkbox>
        </div>

        <el-divider></el-divider>

        <div class="export-config">
          <label
            class="label-title"
            :style="{ color: aceptaInstructivo ? '#303133' : '#C0C4CC' }"
          >
            <b>Paso 3:</b> Seleccione los tipos de riesgo a exportar:
          </label>
          <el-select
            v-model="selectedOptions"
            multiple
            collapse-tags
            :disabled="!aceptaInstructivo"
            placeholder="Seleccionar opciones"
            style="width: 100%; margin-top: 10px"
          >
            <el-option
              v-for="item in options_ds44"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div
          style="
            background-color: #fdf6ec;
            border-left: 5px solid #e6a23c;
            padding: 15px;
            margin-top: 20px;
            border-radius: 4px;
          "
        >
          <small style="color: #606266">
            <i
              class="el-icon-warning"
              style="color: #e6a23c; margin-right: 7px"
            ></i>
            <b>Instrucciones de Seguridad Obligatorias:</b><br />
            <p style="margin-bottom: 5px">
              Debido a políticas de Microsoft, para permitir la carga de datos
              debe seguir estos pasos:
            </p>
            <p style="margin-top: 0">
              <b>Paso A: Antes de abrir el archivo:</b><br />
              1. Clic derecho al archivo -> <b>Propiedades</b>.<br />
              2. Marcar casilla <b>'Desbloquear'</b>.<br />
              3. Clic en <b>Aceptar</b>.
            </p>
            <p>
              <b>Paso B: Al abrir el documento:</b><br />
              4. Clic en <b>'Habilitar edición'</b>.<br />
              5. Clic en <b>'Habilitar contenido'</b>.
            </p>
          </small>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!aceptaInstructivo || selectedOptions.length === 0"
          @click="confirmExport"
        >
          Exportar Documento
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import uuid from "uuid/v4";
import axios from "axios";
import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { canReviewRisk, canChangeRisk } from "@/utils/generalFunctions";
import InventarioTable from "./InventarioTable.vue";
import EditInventory from "./Edit.vue";
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";

export default {
  props: {
    inventory: {
      type: Object,
      required: true,
    },
    contractPeople: {
      type: Array,
    },
    contract: {
      type: Object,
      required: true,
    },
    workflows: {
      type: Object,
      required: true,
    },
    filtro_usuario_riesgo: {
      type: Boolean,
    },
  },
  components: {
    InventarioTable,
    EditInventory,
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {
      aceptaInstructivo: false,
      dialogVisible: false,
      descargoInstructivo: false,
      selectedOptions: [], // Almacena Salud, Seguridad y/o Medioambiente
      options_ds44: [
        { value: "salud", label: "Salud" },
        { value: "seguridad", label: "Seguridad" },
        // { value: "medioambiente", label: "Medioambiente" },
      ],
      loading_ds44: false,
      row: null,
      inventario_selected: {},
      listado_tareas: [],
      dialogtasks: false,
      tipo_accion: "",
      inventarios: [],
      page: 1,
      totalPage: 0,
      paginar: false,
      vencido: false,
      contractType: "Contratista",
      options: [
        {
          value: "Contratista",
          label: "Contratista",
        },
        {
          value: "Propio",
          label: "Propio",
        },
      ],
      inventario_estado: {
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      loading_inv: false,
      search: "",
      tarea_selected: {},
      riesgo_selected: {},
      copyInventoryTask: false,
      tareas_descargas: [],
      downloadTareasDialog: false,
      motivos: [
        {
          value: "Ocurrencia de un evento NMPL4+",
          label: "Ocurrencia de un evento NMPL4+",
        },
        {
          value: "Ocurrencia de un evento con lesión a personas (MT/ LTI/ FA)",
          label: "Ocurrencia de un evento con lesión a personas (MT/ LTI/ FA)",
        },
        {
          value: "Incorporación de una nueva tarea y/o  proceso.",
          label: "Incorporación de una nueva tarea y/o  proceso.",
        },
      ],
      motivo: "",
      dialogMotivo: false,
      load: false,
      borrador: false,
      roles: {
        contractor_coordinator: "Coordinador contratista",
        contractor_hse: "HSE Contratista",
        administrator: "Administrador de contratos",
        coordinator: "Coordinador",
        owner: "Dueño de contrato",
        risk: "Especialista de riesgos",
        hse: "HSE",
        health: "Salud",
        safety: "Seguridad",
        environment: "Medioambiente",
      },
      back_id_tarea: "",
      loading_multiple: false,
      dialogFinish: false,
      total_aprobados: 0,
      total_rechazados: 0,
      opciones_comentarios: [
        {
          value: "Cambiar nombre a riesgo estandarizado",
          label: "Cambiar nombre a riesgo estandarizado",
        },
        {
          value: "Cambiar, (subir o bajar) nivel de MFL",
          label: "Cambiar, (subir o bajar) nivel de MFL",
        },
        {
          value: "Incluir control mitigador",
          label: "Incluir control mitigador",
        },
        {
          value: "Incluir control preventivo",
          label: "Incluir control preventivo",
        },
        {
          value: "Controles no cubren todas las causas",
          label: "Controles no cubren todas las causas",
        },
        {
          value: "No es causa",
          label: "No es causa",
        },
        {
          value: "No es control",
          label: "No es control",
        },
        {
          value: "No es riesgo",
          label: "No es riesgo",
        },
        {
          value: "Otro",
          label: "Otro",
        },
      ],
      dialogEvaluar: false,
      ids: [],
      revisar: [],
      loading_send: false,
      ver_modal_procedimiento: false,
      loading_anual: false,
      editInventory: false,
      sin_cambios: false,
      dialogEvaluacion: false,
      verDetalles: false,
      cambios: [],
      descripcion: "",
      revisiones: [],
      nota: [],
      addReviewer: false,
      backups: [],
      tarea: "",
      window,
      rolesCoordinator: {
        contractor_coordinator: true,
        coordinator: true,
        contractor_hse: false,
        risk: false,
        hse: false,
        health: false,
        safety: false,
        environment: false,
      },
      inventario_estado: {
        "0wasApproved": "Aprobado en actualización",
        "1wasApproved": "Aprobado en actualización",
        undefined: "No iniciado",
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      filtro_tipo_riesgo: {
        "Salud y Seguridad": true,
        "salud y seguridad": true,
        salud: true,
        seguridad: true,
        medioambiente: true,
      },
      isLoading: false,
      isLoadingPDF: false,
      isLoadingPDFTask: false,
      activeTab: "aprobaciones",
      otherVersionsDialog: false,
      oldVersions: {},
      medioambiental: false,
      isLoadingPDFMedioambiente: false,
      auxTasks: null,
      roleCoordinator: {
        coordinator: true,
        contractor_coordinator: true,
      },
      environmentalAlertText: `
        <b>Advertencia: La plataforma detecto que en la actualidad su inventario de riesgos no presenta riesgos o aspectos medioambientales.</b><br>
        <p>
          Esto quiere decir, que mientras su inventario no cuente con riesgos o aspectos medioambientales, el inventario no podrá ser enviado a fase de “Revisión”. Se recomienda incorporar los riesgos mencionados si desea continuar con el proceso de aprobación de su inventario en plataforma.
        </p>
      `,
      environmentalValidation: {
        valido: false,
        comentario: "",
        fecha_validacion: new Date(),
        user_id: this.$store.getters.user._id,
      },
      environmentalConfirmationDialog: false,
      dialogRevisiones: false,
      inventario_edit: {},
      procedureRules: {
        "5a6f78337b772dcfe68241d5": { mfl: 4, rrr: 10 },
        default: { mfl: 3, rrr: 90 },
      },
      rule: { mfl: 3, rrr: 10 },
    };
  },
  watch: {
    search() {
      this.debounceInputSearch();
    },
    contractType() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    },
  },
  async created() {
    this.$store.dispatch("setInventarioCopy", {});
    this.$store.dispatch("resetChanges");
    this.getRespaldos(this.contract._id);
    this.getRevisiones();
    await this.setProcedureRule();

    const vue = this;
    if (this.inventario.tareas !== undefined) {
      this.inventario.tareas.forEach((tarea) => {
        // Mostrar o no pdf medioambiental
        if (tarea.riesgos && !vue.medioambiental) {
          tarea.riesgos.forEach((riesgo) => {
            if (riesgo.medioambiental) {
              vue.medioambiental = true;
            }
          });
        }
      });
    }
    this.$store.dispatch(
      "setStatus",
      this.inventario.wasApproved === true &&
        [0, 1, "0", "1"].includes(parseInt(this.inventario.status))
        ? `${this.inventario.status}wasApproved`
        : this.inventario.status
    );
    /* TUTORIAL */
    if (this.hasTutorial() === false) {
      this.$alert(
        "Nueva funcionalidad para coordinadores de los inventarios, Permite sustituir cualquier riesgo personalizado por uno estandarizado, sin necesidad de cambiar el estado del inventario a borrador.",
        "Información Importante",
        {
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.$confirm(
              "¿Desea ocultar este tutorial en sus próximas sesiones?",
              "Información",
              {
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                type: "warning",
              }
            ).then(() => {
              localStorage.setItem("tutorial_3", "true");
            });
          },
        }
      );
    }
    if (localStorage.getItem("tutorial_3") === "false") {
      localStorage.setItem("tutorial_3", "false");
    }
    this.setAuxTasksAndRiskAlert();
  },
  async mounted() {
    this.isBorrador();
  },
  computed: {
    ...mapGetters({
      actualRole: "actualRole",
    }),
    role() {
      return this.$store.getters.role;
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    activeTasks() {
      if (this.inventario.tareas === undefined) return undefined;
      return this.inventario.tareas.map((tarea) => tarea.id || tarea._id);
    },
    inventario() {
      return this.inventory;
    },
    actualContract() {
      return this.contract;
    },
    actualRole() {
      if (!this.$store.getters.role) return false;
      if (!this.$store.getters.role.role) return false;
      return this.$store.getters.role.role;
    },
    isAdmin() {
      return this.$store.getters.role ? this.$store.getters.role.admin : false;
    },
  },
  methods: {
    resetValidation() {
      this.descargoInstructivo = false; // Resetear el primer paso
      this.aceptaInstructivo = false; // Resetear el segundo paso
      this.selectedOptions = []; // Limpiar selección
    },
    confirmExport() {
      // 1. Creamos una copia local de lo que el usuario seleccionó
      const opcionesParaEnviar = [...this.selectedOptions];

      // 2. Ahora podemos cerrar el diálogo y que se limpie el estado original
      this.dialogVisible = false;

      // 3. Pasamos esa copia a la función de descarga
      this.downloadDS44(opcionesParaEnviar);

      this.$message({
        message: "Generando archivo DS44...",
        type: "success",
      });
    },
    async downloadDS44(opciones) {
      // <--- Ahora recibe las opciones aquí
      try {
        this.loading_ds44 = true;

        // Registro de descarga (Opcional, usando las opciones locales)
        await axios.post(
          `/inventarios/descargaDs44`,
          {
            id_inventario: this.inventario._id,
            id_contrato: this.$store.getters.actualContract._id,
            nombre_contrato: this.$store.getters.actualContract.nombre,
            user_id: this.$store.getters.user._id,
            nombre_usuario: `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`,
            faena_id: this.role.faena_id,
            tipos: opciones, // <--- Usamos la copia segura
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // --- PUNTO CRÍTICO: Codificación de la URL ---
        // Convertimos el array a JSON y luego a un formato seguro para URL
        const tiposEncoded = encodeURIComponent(JSON.stringify(opciones));

        const response = await axios({
          // Usamos la variable codificada para que el backend reciba el array completo
          url: `/inventarios/exportDs44/${this.contract._id}/${tiposEncoded}`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          method: "GET",
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const fileURL = window.URL.createObjectURL(blob);
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;

        // --- CAMBIAMOS A .xlsm ---
        fileLink.setAttribute("download", `${this.contract.nombre}.xlsm`);

        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        window.URL.revokeObjectURL(fileURL);

        this.loading_ds44 = false;
      } catch (error) {
        this.loading_ds44 = false;
        console.error("Error downloading file:", error);
        this.$message.error("Error al generar el archivo XLSM");
      }
    },
    async setProcedureRule() {
      this.rule =
        this.procedureRules[this.$store.getters.role.faena_id] ||
        this.procedureRules.default;
    },
    risksRuleValidation(tarea) {
      var requiere = false;
      tarea.riesgos.forEach((r) => {
        const { mfl } = r.impactos[0];
        const rrr =
          r.impactos[0].factor_severidad * r.impactos[0].factor_probabilidad;
        if (mfl >= this.rule.mfl || rrr >= this.rule.rrr) {
          requiere = true;
        }
      });
      return requiere;
    },
    getTasks(inventory) {
      var tareas = [];
      if (this.filtro_usuario_riesgo === false) {
        return inventory.tareas;
      }
      inventory.tareas.forEach((t) => {
        if (this.auxTasks[t.id || t._id].count > 0) {
          tareas.push(t);
        }
      });
      return tareas;
    },
    getRisks(task) {
      var tipos = [];
      var riesgos = [];
      for (const key in this.filtro_tipo_riesgo) {
        if (this.filtro_tipo_riesgo[key] === true) {
          tipos.push(key);
        }
      }
      task.riesgos.forEach((r) => {
        if (tipos.includes(r.tipo.toLowerCase())) {
          riesgos.push(r);
        }
      });
      return riesgos;
    },
    rowClicked(row) {
      this.collapse_change(row.id || row._id);
      this.row = row;
    },
    collapse_change(id_tarea) {
      if (id_tarea) {
        if (this.$store.getters.role.faena_id !== "5a6f78337b772dcfe68241d5") {
          if (this.back_id_tarea === "" || id_tarea !== this.back_id_tarea) {
            this.back_id_tarea = id_tarea;
            this.ids = [];
            var tarea_temp = this.inventario.tareas.find(
              (x) => x.id === id_tarea || x._id === id_tarea
            );
            tarea_temp.riesgos.forEach((r) => {
              if (r.custom && this.canReviewRisk(r) && r.status === 0) {
                this.ids.push({
                  task: tarea_temp.nombre,
                  task_id: tarea_temp.id || tarea_temp._id,
                  accion: "aprobar",
                  riesgo: r,
                  observaciones: [],
                  comentario: "",
                });
              }
            });
          }
        }
        if (this.$store.getters.role.faena_id === "5a6f78337b772dcfe68241d5") {
          if (this.back_id_tarea === "" || id_tarea !== this.back_id_tarea) {
            this.back_id_tarea = id_tarea;
            this.ids = [];
          }
        }
      }
    },
    async moveUp(index, task) {
      this.$store.dispatch("upTask", index);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(
        `/inventarios/setPositionTask`,
        {
          id_inventario: this.inventario._id,
          indice: index === 0 ? 0 : index - 1,
          tarea: task,
          id_tarea: task.id || task._id,
        },
        config
      );

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
      //this.saveInventory();
    },
    async moveDown(index, task) {
      this.$store.dispatch("downTask", index);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var resp = await axios.post(
        `/inventarios/setPositionTask`,
        {
          id_inventario: this.inventario._id,
          indice: index + 1,
          tarea: task,
          id_tarea: task.id || task._id,
        },
        config
      );

      if (resp.data.status === true) {
        this.$notify({
          duration: 3000,
          title: "Atención",
          message: resp.data.mensaje,
          type: "success",
        });
      }
      //this.saveInventory();
    },
    saveInventory() {
      this.$store.dispatch("createOrUpdateDraft").then((response) => {
        if (response.success) {
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Cambios guardados exitosamente",
            type: "success",
          });
        } else {
          this.$alert(response.message, this.$t("Error"), {
            type: "error",
          });
        }
      });
    },
    async copiarTareaRiesgoInventario(tarea) {
      this.tarea_selected = tarea;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        `Estimado usuario coordinador, por favor, considere el impacto que los diferentes escenarios, pueden generar en la evaluación del riesgo. ¿Deseas Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          if (this.riesgo_selected.custom === true) {
            this.riesgo_selected._id = uuid();
            this.riesgo_selected.status = 0;
            this.riesgo_selected.status_step = 0;
            this.riesgo_selected.status_by = null;
            this.riesgo_selected.status_position = null;
            this.riesgo_selected.status_message = null;
            this.riesgo_selected.status_step_approve = [];
            this.riesgo_selected.status_history = null;
            this.riesgo_selected.status_updated_at = null;
          }
          await axios.post(
            `/inventarios/copiarTareaRiesgoInventario`,
            {
              id_inventory: this.inventario_selected._id,
              tarea: this.tarea_selected,
              riesgo: this.riesgo_selected,
            },
            config
          );
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Riesgo copiado exitosamente",
            type: "success",
          });
          this.getInventory();
          this.handleClose();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    }, 1200),
    async getInventory() {
      await this.$store.dispatch("getInventory", this.contract).then(() => {});
    },
    async copiarRiesgoInventario(row) {
      this.inventario_selected = row.inventario;
      this.inventario_selected["nombre"] = row["nombre"];
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(
        `/inventarios/getTasksInventory`,
        {
          _id: row.inventario._id,
        },
        config
      );

      this.listado_tareas = resp.data.length > 0 ? resp.data[0]["tareas"] : [];
      this.dialogtasks = true;
    },
    copiarTareaInventario(row) {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      this.$confirm(
        `Estimado usuario coordinador, por favor, considere el impacto que los diferentes escenarios, pueden generar en la evaluación del riesgo. ¿Deseas Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          this.tarea_selected.riesgos.forEach((r) => {
            if (r.custom === true) {
              r._id = uuid();
              r.status = 0;
              r.status_step = 0;
              r.status_by = null;
              r.status_position = null;
              r.status_message = null;
              r.status_step_approve = [];
              r.status_history = null;
              r.status_updated_at = null;
            }
          });
          await axios.post(
            `/inventarios/copiarTareaInventario`,
            {
              id_inventory: row.inventario._id,
              tarea: this.tarea_selected,
            },
            config
          );
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Tarea copiada exitosamente",
            type: "success",
          });
          this.getInventory();
          this.handleClose();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatus(row) {
      if (!row.inventario) {
        return "No iniciado";
      }
      if (row.inventario.wasApproved === true) {
        if (row.inventario.status === 1 || row.inventario.status === 0) {
          return "Aprobado en actualización";
        }
      }
      return this.inventario_estado[row.inventario.status];
    },
    paginarInventarios() {
      return this.inventarios.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    listadoInventarios(page, search) {
      const self = this;
      this.loading_inv = true;
      let url = `/contratos/byUFAER?vencido=${this.vencido}&userId=${this.$store.getters.user._id}&faenaId=${this.$store.getters.role.faena_id}`;
      url = this.$store.getters.role.admin
        ? `${url}&role=admin`
        : this.$store.getters.role.area_id === "GeneralAreasRoles"
        ? `${url}&role=allAreas`
        : `${url}&role=${this.$store.getters.role.role}`;
      url += `&actualRole=${this.$store.getters.role.role}`;
      if (this.$store.getters.role.area_id) {
        url = `${url}&areaId=${this.$store.getters.role.area_id}`;
      }
      if (this.$store.getters.role.empresa_id) {
        url = `${url}&empresaId=${this.$store.getters.role.empresa_id}`;
      }
      axios
        .get(
          `${url}&page=${page}&tipo=${this.contractType}&search=${
            search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.inventarios = response.data.contratos.results;
          self.totalPage = response.data.contratos.total;
          self.paginar = response.data.contratos.paginar;
          self.loading_inv = false;
        });
    },
    copyRisks(riesgo) {
      this.tipo_accion = "riesgo";
      this.riesgo_selected = riesgo;
      this.riesgo_selected["_id"] = this.generateUUID();
      this.listadoInventarios(1, "");
      this.copyInventoryTask = true;
    },
    copyTasks(tarea) {
      this.tipo_accion = "tarea";
      this.tarea_selected = JSON.parse(JSON.stringify(tarea));
      if (this.tarea_selected["id"]) {
        this.tarea_selected["id"] = this.generateUUID();
      } else {
        this.tarea_selected["_id"] = this.generateUUID();
      }
      this.listadoInventarios(1, "");
      this.copyInventoryTask = true;
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    async descargarTareasMultiple() {
      this.isLoadingPDFTask = true;
      this.$store
        .dispatch("getPDFTask", {
          inventory_id: this.$store.getters.inventario._id,
          tareas: this.tareas_descargas,
        })
        .then(() => {
          this.isLoadingPDFTask = false;
          this.handleClose();
        });
    },
    handleSelectionChange(val) {
      var result = val.map((v) => v.id || v._id);
      this.tareas_descargas = result;
    },
    nextChangeStatus() {
      if (this.motivo === "") {
        this.dialogMotivo = false;
        this.$alert(
          "Para continuar debe seleccionar un motivo.",
          "Información",
          {
            confirmButtonText: "Aceptar",
            type: "warning",
            callback: (action) => {
              this.dialogMotivo = true;
            },
          }
        );
      } else {
        this.changeStatus("borrador");
      }
    },
    openMotivo() {
      this.dialogMotivo = true;
    },
    async restoreBorrador() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(
        "/inventarios/getTemporalAnual",
        {
          id_inv: this.$store.getters.inventario._id,
        },
        config
      );

      if (resp.data.success === true) {
        this.inventario_edit = JSON.parse(JSON.stringify(resp.data.data));
        this.$store.dispatch("setInventarioCopy", this.inventario_edit);
        this.$store.dispatch("setChange", resp.data.cambios);
        this.borrador = false;
      }
    },
    async deleteTemporalAnual() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(
        "/inventarios/deleteTemporalAnual",
        {
          id_inv: this.$store.getters.inventario._id,
        },
        config
      );
    },
    async isBorrador() {
      this.load = true;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(
        "/inventarios/getTemporalAnual",
        {
          id_inv: this.$store.getters.inventario._id,
        },
        config
      );

      if (resp.data.data.length === 0) {
        this.borrador = false;
      } else {
        this.borrador = true;
      }
      this.load = false;
    },
    async saveTemporal() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var response = await axios.post(
        "/inventarios/temporalAnual",
        {
          inventario: this.$store.getters.inventario_copy,
          cambios: this.$store.getters.cambios,
        },
        config
      );
      this.handleClose();
    },
    refreshCollapse() {
      this.back_id_tarea = "";
      this.ids = [];
    },
    resetIds() {
      this.ids.forEach((item) => {
        item.observaciones = [];
        item.comentario = "";
      });
    },
    revision_multiple() {
      this.$confirm(
        this.$t("¿Está seguro de esta revisión?"),
        this.$t("Atención"),
        { type: "warning" }
      ).then(() => {
        var continuar = true;

        this.getQuantity(this.ids, "rechazar").forEach((item) => {
          if (item.observaciones.length === 0) {
            continuar = false;
            this.$alert(
              this.$t(
                `Al riesgo ${item.riesgo.nombre} de la tarea ${item.task} no tiene observaciones.`
              ),
              this.$t("Atención"),
              {
                type: "error",
              }
            );
          }
          if (item.comentario === "") {
            continuar = false;
            this.$alert(
              this.$t(
                `Al riesgo ${item.riesgo.nombre} de la tarea ${item.task} no tiene comentarios.`
              ),
              this.$t("Atención"),
              {
                type: "error",
              }
            );
          }
        });

        if (continuar === true) {
          this.loading_multiple = true;

          this.ids.forEach(async (item, index) => {
            const statusHistoryVal = {};
            statusHistoryVal.nombre = this.$store.getters.user.nombre;
            statusHistoryVal.nombre += ` ${this.$store.getters.user.apellido}`;
            statusHistoryVal.fecha = this.$moment().format("LLLL");

            // Cambia status segun mfl y estado actual del paso
            let { status } = item.riesgo;
            let statusStep = item.riesgo.status_step;
            const { mfl } = this.getMayorImpacto(item.riesgo);

            const workflow = this.workflows[item.riesgo.tipo.toLowerCase()];
            // mfl = riesgo de mayor nivel
            const steps = workflow.risks[mfl - 1];
            const lastStep = steps.length;
            const actualStep = steps[statusStep];
            let statusStepApprovedByProfiles = item.riesgo
              .status_step_approved_by_profiles
              ? item.riesgo.status_step_approved_by_profiles
              : [];
            let statusHistory = item.riesgo.status_history
              ? item.riesgo.status_history
              : [[]];
            // Revision normal
            if (item.accion === "aprobar") {
              if (this.$store.getters.role.admin) {
                statusHistoryVal.perfil = "superadmin";
                statusStepApprovedByProfiles.push("superadmin");

                if (statusHistory.length === 0) {
                  statusHistory.push([statusHistoryVal]);
                } else {
                  statusHistory[statusHistory.length - 1].push(
                    statusHistoryVal
                  );
                }

                // reset cuando step está listo
                if (
                  statusStepApprovedByProfiles.length >=
                  parseInt(actualStep.minToApprove)
                ) {
                  statusStep += 1;
                  statusStepApprovedByProfiles = [];
                  statusHistory.push([]);
                }
              } else {
                const profile = this.$store.getters.role.role;
                /* if (profile === 'administrator') profile = 'admin'; */
                statusStepApprovedByProfiles.push(profile);
                statusHistoryVal.perfil = profile;

                if (statusHistory.length === 0) {
                  statusHistory.push([statusHistoryVal]);
                } else {
                  statusHistory[statusHistory.length - 1].push(
                    statusHistoryVal
                  );
                }

                if (
                  statusStepApprovedByProfiles.length >=
                  parseInt(actualStep.minToApprove)
                ) {
                  statusStep += 1;
                  statusStepApprovedByProfiles = [];
                  statusHistory.push([]);
                }
              }
              if (statusStep === lastStep) {
                status = 1;
              }
            } else {
              statusStep = -1;
              // como se rechazo el 'historial' tambien
              statusHistory = [[]];
            } // if
            const risk_id = item.riesgo._id;
            let msj = "";
            if (item.observaciones.length > 0) {
              let acciones = "";
              item.observaciones.forEach((a) => {
                acciones += `<li>${a}</li>`;
              });
              msj =
                `<b>Nombre:</b> ${this.username()} <br> <b>Rol</b>: ${
                  this.$store.getters.role.admin === true
                    ? "Administrador de Plataforma"
                    : this.roles[this.$store.getters.role.role]
                } <br> <b>Observaciones: </b> <br> ${acciones} <b>Fecha:</b> ${new Date().toLocaleString()} <br> <b>Observaciones adicionales:</b> <br> ${
                  item.comentario
                } ${
                  item.riesgo.status_message &&
                  item.riesgo.status_message.length > 0
                    ? "<hr style='margin-top: 15px; margin-bottom: 15px;'>"
                    : ""
                } ` +
                `${
                  item.riesgo.status_message &&
                  item.riesgo.status_message.length > 0
                    ? item.riesgo.status_message
                    : ""
                }`;
            } else {
              msj = item.riesgo.status_message;
            }
            const statusBy = `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
            const statusPosition = this.$store.getters.role.admin
              ? "superadmin"
              : this.$store.getters.role.role;
            // aqui se envia
            await this.$store
              .dispatch("updateRiskStatus", {
                id: this.$store.getters.inventario._id,
                task_id: item.task_id,
                risk_id,
                status,
                status_step: statusStep,
                status_by: statusBy,
                status_position: statusPosition,
                status_message: msj,
                status_step_approved_by_profiles: statusStepApprovedByProfiles,
                status_history: statusHistory,
              })
              .then((response) => {
                if (response.status) {
                  // cuando salio todo bien
                  // actualiza los datos del riesgo con los datos locales
                  // para evitar ir a buscar todo el inventario como lo hacia
                  // antes cada vez que se editaba un riesgo
                  const risk = item.riesgo;
                  this.$store.dispatch("InventoryEditRisk", {
                    risk,
                    obj: {
                      status,
                      status_step: statusStep,
                      status_by: statusBy,
                      status_position: statusPosition,
                      status_message: msj,
                      status_step_approved_by_profiles:
                        statusStepApprovedByProfiles,
                      status_history: statusHistory,
                    },
                  });

                  // busca si hay almenos 1 riesgo sin aprobar
                  const resp = this.$store.getters.inventario.tareas.some(
                    (t) =>
                      t.riesgos &&
                      t.riesgos.some((r) => r.custom == true && r.status != 1)
                  );
                  // si no hay entonces el inventario se aprobo
                  // si se aprobo hay que setear la var de contrato que se muestra en select a aprobado
                  if (resp === false) {
                    this.$store.commit("EDIT_INVENTORY", {
                      status: 2,
                      wasApproved: true,
                    });

                    const inventoryId = this.$store.getters.inventario._id;
                    this.$store.dispatch("userContractAssignInventory", {
                      inventoryId,
                      obj: { status: 2 },
                    });
                    this.$store
                      .dispatch(
                        "setDateInventoryApproved",
                        this.$store.getters.inventario
                      )
                      .then(async (response) => {
                        if (response.status === true) {
                        } else {
                          console.log(
                            "La fecha de aprobación no ha podido actualizarse"
                          );
                          this.loading_multiple = false;
                        }
                      });
                    this.$store.dispatch("setStatus", 2);
                  }
                } else {
                  this.$alert(
                    this.$t(
                      "Lo sentimos, surgió un error al actualizar estado. Intente nuevamente."
                    ),
                    this.$t("Atención"),
                    {
                      type: "error",
                    }
                  );
                  this.loading_multiple = false;
                }
              });
            if (index === this.ids.length - 1) {
              this.total_aprobados = this.getQuantity(
                this.ids,
                "aprobar"
              ).length;
              this.total_rechazados = this.getQuantity(
                this.ids,
                "rechazar"
              ).length;
              this.dialogFinish = true;
              this.dialogEvaluar = false;
              this.ids = [];
              this.loading_multiple = false;
              this.refreshCollapse();
              this.setAuxTasksAndRiskAlert();
            }
          });
        }
      });
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    getQuantity(array, status) {
      var newArray = array.filter(function (el) {
        return el.accion === status;
      });
      return newArray;
    },
    openEvaluarTarea(riesgos) {
      this.dialogEvaluar = true;
    },
    showTarea(riesgos) {
      var cumple = false;
      if (riesgos) {
        riesgos.forEach((r) => {
          if (r.custom && r.status === 0) {
            cumple = true;
          }
        });
      }
      return cumple;
    },
    mostrarTarea(riesgos) {
      var arr_riesgos = [];
      riesgos.forEach((r) => {
        if (r.custom && r.status === 0 && this.canReviewRisk(r)) {
          arr_riesgos.push(r._id);
        }
      });
      if (arr_riesgos.length === 0) {
        return false;
      } else {
        return true;
      }
    },
    validarTarea(riesgos) {
      var arr_riesgos = [];
      riesgos.forEach((r) => {
        if (r.custom && r.status === 0 && this.canReviewRisk(r)) {
          arr_riesgos.push(r._id);
        }
      });
      if (this.$store.getters.role.faena_id === "5a6f78337b772dcfe68241d5") {
        if (arr_riesgos.length === 0) {
          return true;
        }
      }
      var arr_ids = this.ids.map((r) => r.riesgo._id);
      var contador = 0;
      arr_ids.forEach((a) => {
        if (arr_riesgos.includes(a)) {
          contador = contador + 1;
        }
      });
      if (contador === arr_riesgos.length) {
        return false;
      } else {
        return true;
      }
    },
    descargarExcel() {
      window.location.href = `https://legacy.bhp.lifeon.cl/data-science/reportes/getInventory/${this.contract._id}`;
    },
    validarAprobadoNull() {
      if (this.revisiones.length === 1) {
        if (this.revisiones[0]["aprobado"] === null) {
          return true;
        }
      }

      if (this.revisiones.length > 1) {
        if (this.revisiones[this.revisiones.length - 1]["aprobado"] === null) {
          return true;
        }
      }
      return false;
    },
    validarAprobado() {
      if (
        ["contractor_coordinator", "coordinator"].includes(
          this.$store.getters.role.role
        )
      ) {
        if (this.revisiones.length === 1) {
          if (this.revisiones[0]["aprobado"] === false) {
            return true;
          }
        }

        if (this.revisiones.length > 1) {
          if (
            this.revisiones[this.revisiones.length - 1]["aprobado"] === false
          ) {
            return true;
          }
        }
      }
      return false;
    },
    async openEditInventory() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var resp = await axios.post(
        "/inventarios/getTemporalAnual",
        {
          id_inv: this.$store.getters.inventario._id,
        },
        config
      );

      if (resp.data.success === true) {
        this.inventario_edit = JSON.parse(JSON.stringify(resp.data.data));
        this.$store.dispatch("setInventarioCopy", this.inventario_edit);
        this.$store.dispatch("setChange", resp.data.cambios);
      } else {
        if (Object.entries(this.$store.getters.inventario_copy).length === 0) {
          var response = await axios.get(
            `/inventarios/getLastAnualReviewer/${this.inventario.contrato_id}`,
            config
          );
          if (response.data.length === 0) {
            this.inventario_edit = JSON.parse(JSON.stringify(this.inventory));
          } else {
            this.inventario_edit = JSON.parse(JSON.stringify(response.data));
          }
          this.$store.dispatch("setInventarioCopy", this.inventario_edit);
        } else {
          this.inventario_edit = this.$store.getters.inventario_copy;
          this.$store.dispatch("setInventarioCopy", this.inventario_edit);
        }
      }

      this.editInventory = true;
    },
    withoutChanges() {
      this.sin_cambios = true;
      this.addRevision();
    },
    setStatusEvaluacion(status) {
      var mensaje = "";
      var self = this;
      if (status === true) {
        mensaje = "---";
        this.verificarAnual(status, mensaje);
      }
      if (status === false) {
        this.$prompt("Ingrese sus observaciones", "Observaciones", {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
        })
          .then(({ value }) => {
            self.verificarAnual(status, value);
          })
          .catch(() => {
            return false;
          });
      }
    },
    async verificarAnual(status, mensaje) {
      this.loading_anual = true;

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      var respuesta = await axios.get(
        `/inventarios/getLastAnualReviewer/${this.inventario.contrato_id}`,
        config
      );
      if (respuesta.data.length === 0) {
        this.inventario_edit = JSON.parse(JSON.stringify(this.inventory));
      } else {
        this.inventario_edit = JSON.parse(JSON.stringify(respuesta.data));
      }
      this.$store.dispatch("setInventarioCopy", this.inventario_edit);

      var self = this;

      this.$confirm("¿Está seguro que desea continuar?", "Información", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(async () => {
          if (this.revisiones.length > 1) {
            this.revisiones[this.revisiones.length - 1]["aprobado"] = status;
            this.revisiones[this.revisiones.length - 1]["mensaje"] = mensaje;
          }

          if (this.revisiones.length === 1) {
            this.revisiones[0]["aprobado"] = status;
            this.revisiones[0]["mensaje"] = mensaje;
          }

          this.inventario_edit.tareas.forEach((t) => {
            if (t.riesgos) {
              t.riesgos.forEach((r) => {
                if (r.status === 0) {
                  r["anual"] = true;
                  r["status"] = 1;
                }
              });
            }
          });

          axios
            .post(
              `/inventarios/setEvaluacionAnual`,
              {
                role:
                  this.$store.getters.role.admin === true
                    ? "admin"
                    : this.$store.getters.role.role,
                id: this.inventario._id,
                contrato: this.contract._id,
                revisiones: this.revisiones,
                status: status,
                mensaje: mensaje,
              },
              config
            )
            .then(async (response) => {
              self.loading_anual = false;
              if (response.data.status === true) {
                self.getRevisiones();
                self.closeDialogEvaluaciones();
                self.$alert(
                  `Revisión anual ${
                    status === true ? "aprobada" : "rechazada"
                  } correctamente.`,
                  "Atención",
                  {
                    confirmButtonText: "Aceptar",
                    type: "success",
                    callback: (action) => {
                      // location.reload();
                    },
                  }
                );
              }
            });
        })
        .catch(() => {
          this.loading_anual = false;
        });
    },
    closeDialogEvaluaciones() {
      this.dialogEvaluacion = false;
      this.verDetalles = false;
    },
    setCambios(cambio) {
      this.cambios = cambio;
      this.verDetalles = true;
    },
    deleteCambio(id) {
      var pos = this.nota
        .map(function (e) {
          return e.id;
        })
        .indexOf(id);
      if (pos !== -1) {
        this.nota.splice(pos, 1);
      }
    },
    getHumanDate: function (date) {
      return moment(date).format("LL, h:mm:ss a");
    },
    formatDate: function (date) {
      return moment(date).format("LL");
    },
    closeDialogRevisiones() {
      this.dialogRevisiones = false;
      this.verDetalles = false;
    },
    openDialogListReviewer() {
      this.dialogRevisiones = true;
    },
    openDialogReviewer() {
      this.addReviewer = true;
    },
    closeReviewer() {
      this.addReviewer = false;
      this.nota = [];
      this.descripcion = null;
      this.sin_cambios = false;
    },
    validarRevisar(inventario, contract) {
      if (
        inventario &&
        ["2", 2].includes(inventario.status) &&
        this.isActiveContract(contract)
      ) {
        if (this.revisiones.length === 0) {
          if (this.diasDiff(inventario.created_at) >= 365) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            this.diasDiff(
              this.revisiones[this.revisiones.length - 1]["date"]
            ) >= 365 ||
            this.revisiones[this.revisiones.length - 1]["aprobado"] === false ||
            this.revisiones[this.revisiones.length - 1]["aprobado"] === null
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    addRevision() {
      this.$confirm(
        "¿Está seguro que deseas enviar a revisión los cambios realizados?",
        "Información",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(async () => {
        this.loading_send = true;
        if (
          this.$store.getters.cambios.length > 0 ||
          this.sin_cambios === true
        ) {
          if (this.sin_cambios === true) {
            if (
              Object.entries(this.$store.getters.inventario_copy).length === 0
            ) {
              const config = {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              };
              var response = await axios.get(
                `/inventarios/getLastAnualReviewer/${this.inventario.contrato_id}`,
                config
              );
              if (response.data.length === 0) {
                this.inventario_edit = JSON.parse(
                  JSON.stringify(this.inventory)
                );
              } else {
                this.inventario_edit = JSON.parse(
                  JSON.stringify(response.data)
                );
              }
              this.$store.dispatch("setInventarioCopy", this.inventario_edit);
            } else {
              this.inventario_edit = this.$store.getters.inventario_copy;
              this.$store.dispatch("setInventarioCopy", this.inventario_edit);
            }
          }
          var self = this;
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };
          axios
            .post(
              `/inventarios/addReviewer`,
              {
                id: this.inventario._id,
                nota:
                  this.sin_cambios === false
                    ? this.$store.getters.cambios
                    : [
                        {
                          num: this.$store.getters.cambios.length + 1,
                          id: this.$store.getters.cambios.length + 1,
                          tarea: "---",
                          riesgo: "---",
                          descripcion:
                            "No se realizan cambios en el Inventario de Riesgos",
                          date: new Date(),
                        },
                      ],
                aprobado: null,
                mensaje: "Sin comentarios",
                inventario: this.$store.getters.inventario_copy,
              },
              config
            )
            .then(async (response) => {
              if (response.data.success === true) {
                self.deleteTemporalAnual();
                self.getRevisiones();
                self.$store.dispatch("resetChanges");
                self.closeReviewer();
                self.loading_send = false;
                self.$alert(
                  self.$t("Revisión agregada correctamente."),
                  self.$t("Atención"),
                  {
                    type: "success",
                  }
                );
              } else {
                self.loading_send = false;
                self.$alert(
                  self.$t(
                    "Ocurrió un problema al intentar agregar la revisión."
                  ),
                  self.$t("Atención"),
                  {
                    type: "danger",
                  }
                );
              }
            });
        } else {
          this.loading_send = false;
          this.$alert(
            this.$t(
              "Para continuar debes ingresar una nota referente a la revisión del inventario."
            ),
            this.$t("Atención"),
            {
              type: "warning",
            }
          );
        }
      });
    },
    diasDiff(date) {
      var fecha1 = moment(date);
      var fecha2 = moment();
      return fecha2.diff(fecha1, "days");
    },
    dateFromObjectId(objectId) {
      return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
    },
    hasTutorial() {
      if (localStorage.getItem("tutorial_3") === "true") {
        return true;
      } else {
        return false;
      }
    },
    getPDFBackup(data) {
      var body = {
        id: data.id,
        version: data.version,
      };
      this.$store.dispatch("getPDFById", body).then(() => {});
    },
    async getRespaldos(contract_id) {
      var self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(`/inventarios/getBackups/${contract_id}`, config)
        .then((response) => {
          self.backups = response.data;
        });
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTablaPloma ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorSaludySeguridad";
        } else if (
          row.impactos[0].categoria === "Medioambiente" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    async getRevisiones() {
      var self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      axios
        .get(
          `/inventarios/getRevisiones/${this.$store.getters.inventario._id}`,
          config
        )
        .then((response) => {
          self.revisiones = response.data;
        });
    },
    async updateInventory(inventory) {
      await this.$store.dispatch("setInventario", inventory);
      const vue = this;
      for (let index = 0; index < 3; index++) {
        if (this.inventario.tareas !== undefined) {
          this.setAuxTasksAndRiskAlert();
        }
      }
    },

    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") return true;
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    /* canReviewRisk(risk) {
      if (!risk.custom) return false;
      if (risk.status_step === -1) return false;
      if (this.$store.getters.role.admin && risk.status !== 1) return true;
      const obj = {
        user: this.$store.getters.user,
        risk,
        contract: this.contract,
        actualProfile: this.actualRole,
        workflows: this.workflows,
      };
      const ret = canReviewRisk(obj);
      return ret;
    }, */
    goBack() {
      window.history.go(-1);
    },
    handleClose() {
      this.search = "";
      this.dialogtasks = false;
      this.copyInventoryTask = false;
      this.$store.dispatch("setStep", 1);
      this.otherVersionsDialog = false;
      this.editInventory = false;
      this.dialogMotivo = false;
      this.motivo = "";
      this.downloadTareasDialog = false;
      this.tareas_descargas = [];
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async getInventory() {
      // Recupera inventario del contrato
      if (
        !(
          this.$store.getters.inventario &&
          this.$store.getters.inventario.contrato_id === this.contract._id
        )
      ) {
        const self = this;
        await this.$store.dispatch("getInventory", this.contract).then(() => {
          self.inventario = self.$store.getters.inventario;
        });
      }
    },
    setAuxTasksAndRiskAlert() {
      try {
        let taskId = "default";
        this.auxTasks = {};
        let canChange;
        this.auxTasks[taskId] = { tarea_id: "default", count: 0 };

        if (this.inventario.tareas) {
          this.inventario.tareas.forEach((tarea) => {
            taskId = tarea._id || tarea.id;
            this.auxTasks[taskId] = { count: 0, show: false };
            // Mapear los riesgos
            if (tarea.riesgos) {
              tarea.riesgos.forEach((riesgo) => {
                canChange = this.roleCoordinator[this.actualRole]
                  ? this.canChangeRisk(riesgo)
                  : this.canReviewRisk(riesgo);

                // Contar riesgos a evaluar por el usuario revisor
                if (canChange) {
                  this.auxTasks[taskId].count += 1;
                } // if
              }); // forEach
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    canChangeRisk(risk) {
      return canChangeRisk({ risk, profile: this.actualRole });
    },
    canReviewRisk(risk) {
      if (!risk.custom) return false;
      if (this.$store.getters.role.admin === true && risk.status === 0)
        return true;
      const obj = {
        user: this.$store.getters.user,
        risk,
        contract: this.contract,
        actualProfile: this.$store.getters.role.role,
        workflows: this.workflows,
      };
      let ret = canReviewRisk(obj);
      return ret;
    },
    otherVersions() {
      this.listPDFs();
      this.otherVersionsDialog = true;
    },
    goToTasks() {
      const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
      this.$router.push({
        path: url,
      });
    },

    async downloadPDF() {
      this.isLoadingPDF = true;
      this.$store.dispatch("getLastPDF").then(() => {
        this.isLoadingPDF = false;
      });
    },
    downloadPDFReview() {
      this.isLoadingPDF = true;
      this.$store.dispatch("getReviewPDF").then(() => {
        this.isLoadingPDF = false;
      });
    },
    downloadPDFMedioambiente() {
      this.isLoadingPDFMedioambiente = true;
      this.$store.dispatch("getPDFMedioambiente").then(() => {
        this.isLoadingPDFMedioambiente = false;
      });
    },
    downloadPDFTask(id) {
      this.isLoadingPDFTask = true;
      this.$store
        .dispatch("getPDFTask", {
          inventory_id: this.$store.getters.inventario._id,
          tareas: id,
        })
        .then(() => {
          this.isLoadingPDFTask = false;
        });
    },
    abrirOldPDF(url) {
      const windowReference = window.open();
      windowReference.location = url;
    },
    listPDFs() {
      const vue = this;
      this.$store.dispatch("getPDFs").then((response) => {
        response.forEach((element) => {
          const date = element.split("/").pop().split(".").shift(); // returns 'two'
          Vue.set(vue.oldVersions, date, element);
        });
      });
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    async changeStatus() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var self = this;

      this.$confirm(
        "`Al cambiar el estado de este inventario a BORRADOR debe tener en cuenta que podrá realizar modificaciones en el inventario y se volverá a activar el flujo de aprobación una vez que se vuelva a enviar a REVISIÓN, tenga en cuenta que la información no modificada se mantendrá vigente en el inventario. ¿Seguro que desea continuar?`",
        "Confirmación",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          this.isLoading = true;
          await axios.post(
            "/inventarios/cambioBorrador",
            {
              _id: this.$store.getters.inventario._id,
              motivo: this.motivo,
              action: `El estado del inventario ${this.$store.getters.actualContract.nombre} ha sido actualizado a borrador.`,
              user: self.username(),
              date: new Date(),
              type: "update",
            },
            config
          );
          this.$store.dispatch("setTareaVista", "");
          this.$alert(
            this.$t("Inventario modificado exitosamente"),
            this.$t("Atención"),
            {
              type: "success",
            }
          ).then(() => {
            this.handleClose();
            window.location.href = `${this.getDomain()}/es/inventario/${
              this.$store.getters.actualContract._id
            }/editar`;
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getDomain() {
      return location.protocol + "//" + window.location.host;
    },
    openEnvironmentalConfirmationDialog(valid) {
      this.environmentalValidation.valido = valid;
      this.environmentalConfirmationDialog = true;
    },
    async sendEnvironmentalValidation() {
      this.isLoading = true;

      // Definir estado del inventario
      // 0: Borrador, 1: En Revisión, 2: Aprobado, 3: Importado, 4: Validación Medioambiente
      var status = 4;
      let riskPending = [];
      if (this.environmentalValidation.valido) {
        status = 1;
        this.inventario.tareas.forEach((tarea) => {
          tarea.riesgos.forEach((riesgo) => {
            if (riesgo.custom === true && riesgo.status !== 1) {
              riskPending.push(riesgo);
            }
          });
        });
        if (riskPending.length === 0) {
          status = 2;
        }
      } else {
        status = 0;
      } // if

      // Set Inventario y validación medioambiental
      const inventario = Object.assign({}, this.inventory);
      inventario.status = status;
      if (!inventario.validacion_medioambiental) {
        inventario.validacion_medioambiental = [];
      }
      this.environmentalValidation.fecha_validacion = new Date();
      inventario.validacion_medioambiental.push(this.environmentalValidation);

      // Registrar cambios en BD
      this.$store.dispatch("setInventario", inventario).then(() => {
        this.$store.dispatch("saveInventario").then(async (response) => {
          this.isLoading = false;
          if (response.status) {
            const config = {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            };
            var self = this;
            axios
              .post(
                "/inventarios/uptadeHistoryInventory",
                {
                  id_inventory: self.inventario._id,
                  action: `El inventario ${self.contract.nombre} ha sido ${
                    status === 1
                      ? "validado"
                      : status === 0
                      ? "rechazado"
                      : "validado"
                  } por el especialista de medioambiente.`,
                  user: self.username(),
                  date: new Date(),
                  type: "update",
                },
                config
              )
              .then(function (response) {});
            this.$alert(
              this.$t("Validación/Rechazo registrado exitosamente"),
              this.$t("Atención"),
              {
                type: "success",
              }
            );
            // actualizar el contrato en el lado cliente
            const { userContracts } = this.$store.getters;
            const contractToUpdate = userContracts.find(
              (c) => c._id === this.contract._id
            );
            if (contractToUpdate) {
              const invToUp = { ...contractToUpdate.inventario };
              if (invToUp) {
                invToUp.status = status;
                this.$store.dispatch("contractAssign", {
                  obj: contractToUpdate,
                  val: { inventario: invToUp },
                });
              } // if
            } // if
            // Redireccón a seleccón de inventarios
            this.$router.push({ name: "inventorySelectPage" });
          } else {
            this.$alert(response.message, "Atención", {
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style>
.el-collapse-item__header {
  line-height: 18px !important;
  height: 100% !important;
  padding: 10px !important;
}
</style>

<style scoped>
.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 10px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}

.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 10px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}

.estadoHeader {
  margin-top: 50px;
  text-align: center;
}

.estadoHeader .el-tag {
  font-size: 22px;
  height: auto;
  line-height: normal;
  padding: 5px 40px;
}

.info {
  margin-bottom: 60px;
}

.pdfDate {
  margin-bottom: 10px !important;
}

#modify-status .el-tag {
  margin: 0 10px;
}

.contenedor_tarea {
  width: 100%;
}

.inventario_estado {
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 5px;
  border-radius: 3px;
  margin-right: 15px;
}

.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}

.img_pdf {
  height: 30px;
  margin-bottom: 5px;
}

.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  margin-right: 15px;
}

.margen_r_l_20px {
  margin-right: 20px;
  margin-left: 20px;
}

.img-change-status {
  margin-top: 10px;
}

.dislplay_0 {
  display: none;
}

.text_align_right {
  text-align: right;
}

.paddingContent {
  padding: 10px;
  height: 17px;
}

.color_grey {
  color: #404040;
}

.header {
  background-color: #242424 !important;
  color: #ffffff !important;
  padding: 0px !important;
  font-size: 14px;
}

.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}
</style>
